<template>
  <div class="PSLKanda4Pro">
    <ValidationObserver ref="observer">
      <ValidationProvider :name="$t('first_name')" :rules="'required|max:100'" :custom-messages="customErrorMessage($t('first_name'), '100')" v-slot="{ errors }">
        <div class="small-text-field">
          <div class="registerlabel">{{ $t("first_name") }} <span class="red--text">*</span></div>
          <v-text-field :hide-details="errors.length ? false : true" :error-messages="errors" :placeholder="$t('first_name')" v-model="input.first_name" height="30" solo rounded> </v-text-field>
        </div>
      </ValidationProvider>
      <ValidationProvider :name="$t('last_name')" :rules="'required|max:100'" :custom-messages="customErrorMessage($t('last_name'), '100')" v-slot="{ errors }">
        <div class="small-text-field">
          <div class="registerlabel">{{ $t("last_name") }} <span class="red--text">*</span></div>
          <v-text-field :hide-details="errors.length ? false : true" :error-messages="errors" v-model="input.last_name" :placeholder="$t('last_name')" height="30" solo rounded> </v-text-field>
        </div>
      </ValidationProvider>
      <div class="small-text-field form-control">
        <div class="registerlabel">{{ $t("date_of_birth") }} <span class="red--text">*</span></div>
        <ValidationProvider :name="$t('date_of_birth')" :rules="'required'" :custom-messages="customErrorMessage($t('date_of_birth'))" v-slot="{ errors }">
          <BirthdayPicker v-model="input.dob">
            <v-text-field :label="$t('date_of_birth')" :error-messages="errors" readonly0 solo rounded :value="dateWithFormatted" :hide-details="errors.length > 0 ? false : true"> </v-text-field>
          </BirthdayPicker>
        </ValidationProvider>
      </div>
      <ValidationProvider :name="$t('phone_number')" :rules="'required|max: 20'" v-slot="{ errors }" :custom-messages="customErrorMessage($t('phone_number'), '15')">
        <div class="small-text-field">
          <div class="registerlabel">{{ $t("phone_number") }} <span class="red--text">*</span></div>
          <vue-tel-input-vuetify v-model="input.phone_number" :defaultCountry="'TH'" :valid-characters-only="true" :error-messages="errors.length > 0 && !isValidPhone ? errors : isValidPhone !== null && !isValidPhone ? errorInvalidPhone : []" rounded solo :placeholder="$t('phone_number')" @input="onInput" :hide-details="true"></vue-tel-input-vuetify>
          <span v-if="errors" style="color: #b71c1c; font-size: 12px; line-height: 12px; padding-left: 12px;">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
      <ValidationProvider key="Email" :name="$t('email')" :rules="'required|email|max: 100'" v-slot="{ errors }" :custom-messages="customErrorMessage($t('email'), '100')">
        <div class="small-text-field">
          <div class="registerlabel">{{ $t("email") }} <span class="red--text">*</span></div>
          <v-text-field :hide-details="errors.length ? false : true" :error-messages="errors" v-model="input.email" :placeholder="$t('email')" height="30" solo rounded> </v-text-field>
        </div>
      </ValidationProvider>
      <ValidationProvider
        :name="$t('rop_number')"
        v-slot="{ errors }"
        :rules="{
          alpha_num: true,
          max: 7,
          regex: /([a-zA-Z]{2})(\d{5})/,
        }"
        :custom-messages="customErrorMessage($t('rop_number'), '7')"
      >
        <div class="small-text-field">
          <div class="registerlabel">{{ $t("rop_number") }}</div>
          <v-text-field :hide-details="errors.length ? false : true" :error-messages="errors" v-model="input.rop_number" :placeholder="$t('rop_number')" height="30" solo rounded> </v-text-field>
        </div>
      </ValidationProvider>
      <ValidationProvider name="nationality" v-slot="{ errors }" :rules="'max: 50'" :custom-messages="customErrorMessage($t('nationality'))">
        <div class="small-text-field">
          <div class="registerlabel">{{ $t("nationality") }}</div>
          <v-autocomplete
            v-model="input.nationality"
            :items="nationalityOptions"
            :error-messages="errors"
            :label="$t('nationality')"
            solo
            rounded
            filled
            hide-details
            :menu-props="{
              overflowY: true,
              zIndex: 2,
              rounded: 'lg',
              maxHeight: 190,
            }"
          ></v-autocomplete>
        </div>
      </ValidationProvider>
      <ValidationProvider :name="$t('passport_no')" v-slot="{ errors }" :rules="'alpha_num|max: 20'" :custom-messages="customErrorMessage($t('passport_no'), '20')">
        <div class="small-text-field">
          <div class="registerlabel">{{ $t("passport_no") }}</div>
          <v-text-field :hide-details="errors.length ? false : true" :error-messages="errors" v-model="input.passport_no" :placeholder="$t('passport_no')" height="30" solo rounded> </v-text-field>
        </div>
      </ValidationProvider>
    </ValidationObserver>
    <div class="text-center mt-9">
      <v-btn class="btn-purple" dark width="200px" rounded :loading="saveloading" @click="submit">
        {{ type == "add" ? $t("register") : $t("save") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CustomInput from "./CustomInput.vue";
import BirthdayPicker from "@/components/BirthdayPicker.vue";
import nationality from "@/data/nationality.js";
import i18n from "@/plugins/i18n";
import moment from "moment";
import VueTelInputVuetify from "vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue";

export default {
  props: ["value", "type"],
  components: {
    CustomInput,
    BirthdayPicker,
    VueTelInputVuetify,
  },
  data() {
    return {
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      modal: false,
      saveloading: false,
      input: {
        first_name: "",
        last_name: "",
        dob: "",
        phone_number: "",
        email: "",
        rop_number: "",
        nationality: "",
        passport_no: "",
      },
      nationalityOptions: nationality,
      computedPhoneNumber: null,
      isValidPhone: null,
      errorInvalidPhone: [this.$t("error_message_phone")],
    };
  },
  mounted() {
    let vm = this;

    if (vm.value) {
      vm.input = {
        first_name: vm.value.first_name,
        last_name: vm.value.last_name,
        dob: vm.value.dob,
        phone_number: vm.value.phone_number,
        email: vm.value.email,
        rop_number: vm.value.rop_number,
        nationality: vm.value.nationality,
        passport_no: vm.value.passport_no,
      };
      vm.computedPhoneNumber = vm.value.phone_number;
    }
  },
  computed: {
    moment() {
      return moment;
    },
    dateWithFormatted() {
      return this.input.dob ? moment(this.input.dob).format("DD/MM/YYYY") : "";
    },
    flag() {
      return i18n.locale;
    },
  },
  methods: {
    async submit() {
      let vm = this;
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        if (vm.type == "add") {
          let receive_promotion_status = vm.$store.state.receivePromotionStatus !== "" ? vm.$store.state.receivePromotionStatus : "";
          let sensitive_consent = vm.$store.state.consentSensitiveStatus !== "" ? vm.$store.state.consentSensitiveStatus : "";
          let pdpa_consent = vm.$store.state.checkboxConsentPDPA !== "" ? vm.$store.state.checkboxConsentPDPA : "";

          vm.saveloading = true;
          var data = {
            userid: vm.$store.state.userid,
            pageid: vm.query.pageid,
            first_name: vm.input.first_name,
            last_name: vm.input.last_name,
            dob: vm.input.dob,
            phone_number: vm.computedPhoneNumber,
            email: vm.input.email,
            rop_number: vm.input.rop_number,
            nationality: vm.input.nationality,
            passport_no: vm.input.passport_no,
            receive_promotion: receive_promotion_status,
            sensitive_consent: sensitive_consent,
            pdpa_consent,
          };

          axios
            .post(`${this.serverUrl}v1/member/regis`, data, {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            })
            .then(async (response) => {
              vm.saveloading = false;
              if (response.data.responsecode == 200) {
                vm.$emit("onSubmitRegister");

                if (vm.flag == "en") {
                  vm.$store.dispatch("sendMessage", "Registration Successfully");
                } else {
                  vm.$store.dispatch("sendMessage", "ลงทะเบียนสำเร็จ");
                }
              } else {
                await vm.$swal.fire({
                  text: reason,
                  confirmButtonColor: "#1C4220",
                  confirmButtonText: vm.$t("ok"),
                });

                if (vm.query.apptype == "line") {
                  vm.$liff.closeWindow();
                } else {
                  vm.$store.dispatch("messengerClose");
                }
              }
            });
        } else {
          let memberId = vm.$store.state.member.memberid;
          vm.saveloading = true;
          var data = {
            first_name: vm.input.first_name,
            last_name: vm.input.last_name,
            dob: vm.input.dob,
            phone_number: vm.computedPhoneNumber,
            email: vm.input.email,
            rop_number: vm.input.rop_number,
            nationality: vm.input.nationality,
            passport_no: vm.input.passport_no,
          };
          axios
            .post(`${this.serverUrl}v1/member/updateMember/${memberId}`, data, {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            })
            .then(async (response) => {
              vm.saveloading = false;
              if (response.data.responsecode == 200) {
                await vm.$store.dispatch("getMemberByUserId");
                vm.$emit("onEditSuccess");
              } else {
                await vm.$swal.fire({
                  text: reason,
                  confirmButtonColor: "#1C4220",
                  confirmButtonText: vm.$t("Ok"),
                });

                if (vm.query.apptype == "line") {
                  vm.$liff.closeWindow();
                } else {
                  vm.$store.dispatch("messengerClose");
                }
              }
            });
        }
      }
    },
    customErrorMessage(val, max = null) {
      let message = {
        required: `${this.$t("error_message_required")} ${val}`,
        max: `${val} ${this.$t("error_message_max")} ${max} ${this.$t("characters")}`,
        email: `${val} ${this.$t("error_message_email")}`,
        alpha_num: `${val} ${this.$t("error_message_alpha_num")}`,
        regex: `${val} ${this.$t("error_message_regex")}`,
      };
      return message;
    },
    onInput(formattedNumber, { number, valid }) {
      this.computedPhoneNumber = number.e164;
      this.input.phone_number = number.significant;
      this.isValidPhone = valid;
    },
  },
};
</script>

<style lang="scss" scoped>
.small-text-field {
  margin-bottom: 16px;
}
.small-text-field .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
.registerlabel {
  color: #330066;
  padding-bottom: 12px;
  padding-left: 8px;
}
</style>
